//import "./safetyforms.css";
import { camelCase, groupBy, orderBy } from 'lodash';
import moment from "moment";
import { useContext, useEffect, useReducer, useState } from "react";
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import "react-dropdown/style.css";
import { useForm } from "react-hook-form";
import { FaCalendar, FaCheckCircle, FaChevronLeft, FaChevronRight, FaExclamationTriangle, FaPlus, FaSpinner, FaTimesCircle, FaTrash } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import styled from "styled-components";
import { resetPagination } from "../common/slices/globalActions";
import { selectActive } from "../common/slices/location";
import { deleteTimeSheet, fetchListTimesheets, fetchTimeEntriesByCrewMemberId, getTimeSheet, selectActiveTimesheet, selectLoading, selectPagination, selectTimeEntries, selectTimesheetById, selectTimesheets, setActiveTimesheet } from "../common/slices/timesheet";
import theme from "../common/theme";
import { pathNames } from "../constants";
import ActionContainer from "./ActionContainer";
import { ButtonBase, DarkButton, LightButton, WhiteButton } from "./Buttons";
import { DropdownContainer, DropdownContent } from "./Dropdown";
import FormSelectCrewMember from "./FormSelectCrewMember";
import Layout from "./Layout";
import ModalConfirm from "./ModalConfirm";
import ModalEditTimeEntry from "./ModalEditTimeEntry";
import ModalEditTimesheet from "./ModalEditTimesheet";
import ModalTimesheet from "./ModalTimesheet";
import ModalTimesheetReport from "./ModalTimesheetReport";
import Row from "./Row";
import { MenuItem, Table, TableData, TableDataLast, TableDataUnderline, TableFooter, TableHeader, TableMenu, TableRow } from "./Table";
import { Tab, TabContainer, TabContent } from "./Tabs";
import { H1, Pmb } from "./Typography";
import { ErrorContext } from '../ErrorContext';

const ScreenListTimesheets = () => {

    return (

        <Layout>
            <H1 style={{ marginTop: '2rem' }}>Time Sheets</H1>
            <TabContainer>
                <Row>
                    <Tab tabId={0}>Time Sheet</Tab>
                    <Tab tabId={1}>Calendar</Tab>
                </Row>

                <TimeSheetTabContainer />
                <CalendarTabContainer />
            </TabContainer>
        </Layout>
    )
}

const TimeSheetTabContainer = () => (
    <TabContent tabId={0}>
        <TimeSheetTab />
    </TabContent>
)

const TimeSheetTab = () => {
    const errorContext = useContext(ErrorContext);
    const dispatch = useDispatch();
    const nav = useNavigate();
    const { id } = useParams();
    const locationId = useSelector(selectActive);
    const timesheets = useSelector(selectTimesheets);
    const pagination = useSelector(selectPagination);
    const loading = useSelector(selectLoading);
    const timesheet = useSelector(selectActiveTimesheet);
    const [timesheetReportModal, setTimesheetReportModal] = useState(false);
    const [newTimesheetModal, setNewTimesheetModal] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);


    useEffect(() => {
        (async () => {
            try {
                if (locationId) {
                    dispatch(resetPagination())
                    await dispatch(fetchListTimesheets(locationId));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to get timesheets", forSupport: ex.message })
            }
        })()
    }, [locationId, dispatch]);

    useEffect(() => {
        (async () => {
            try {
                if (id) {
                    const timesheet = await dispatch(getTimeSheet(id));
                    dispatch(setActiveTimesheet(timesheet));
                } else {
                    dispatch(setActiveTimesheet(null));
                }
            } catch (ex) {
                errorContext.setError({ errorMessage: "Failed to get timesheet", forSupport: ex.message })
            }
        })()
    }, [id, dispatch])

    const onTimesheetClick = (d) => {
        nav(`${pathNames.TIMESHEETS}/${d.id}`);
        // setTimesheetReportModal(true);
    };

    const onDeleteTimesheet = async () => {
        try {
            setShowConfirm(false);
            await dispatch(deleteTimeSheet({ id: showConfirm }));
            toast.success("Timesheet Deleted!");
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to delete timesheet", forSupport: ex.message })
        }
    };

    const onNextPage = async () => {
        try {
            await dispatch(fetchListTimesheets(locationId, undefined, pagination.nextToken));
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to get next page of timesheets", forSupport: ex.message })
        }
    }

    const onPrevPage = async () => {
        try {
            await dispatch(fetchListTimesheets(locationId, undefined, pagination.previousTokens[pagination.previousTokens.length - 2], false));
        } catch (ex) {
            errorContext.setError({ errorMessage: "Failed to get previous page of timesheets", forSupport: ex.message })
        }
    }

    return (
        <>
            <ActionContainer>
                <div style={{ flex: 2 }} />
                <DarkButton onClick={() => setTimesheetReportModal(true)}>Generate Report</DarkButton>
                <LightButton onClick={() => setNewTimesheetModal(true)}><FaPlus /> Create Time Sheet</LightButton>
            </ActionContainer>
            <Table>
                <thead>
                    <tr>
                        <TableHeader colSpan={2}>Customers</TableHeader>
                        <TableHeader style={{ width: '10%' }}>Hours</TableHeader>
                        <TableHeader style={{ width: '25%' }}>Date Submitted</TableHeader>
                        <TableHeader style={{ width: '25%' }}>Foreman</TableHeader>
                    </tr>
                </thead>
                <tbody>
                    {timesheets.map((ts) => (
                        <TableRow key={ts.id} onClick={() => onTimesheetClick(ts)}>
                            <TableData style={{ width: '1rem' }}>{ts.allApproved ? <FaCheckCircle title="Approved" /> : <FaExclamationTriangle title="Not Approved" />}</TableData>
                            <TableDataUnderline>{ts.customers?.map(cx => cx.name).join(', ')}</TableDataUnderline>
                            <TableData>{moment.duration({ hours: ts.hours }).format('*h:mm [h]')}</TableData>
                            <TableData>{moment(ts.date).format("MMM D, YYYY [at] h:mm A")}</TableData>
                            <TableDataLast>
                                {ts?.foreman?.active ? null : <FaTimesCircle title="Inactive User" style={{ marginRight: '0.25rem' }} />}
                                {ts?.foreman?.name}
                                <TableMenu>
                                    <MenuItem onClick={(e) => { e.stopPropagation(); setShowConfirm(ts.id); }}>
                                        Delete
                                        <FaTrash style={{ marginLeft: "auto" }} />
                                    </MenuItem>
                                </TableMenu>
                            </TableDataLast>
                        </TableRow>
                    ))}
                    {
                        !loading && !timesheets.length && <TableRow><TableData colSpan={5}>No timesheets, please adjust your filter</TableData></TableRow>
                    }
                </tbody>
            </Table>
            <TableFooter>
                {loading && <FaSpinner className='fa-spin' />}
                <ButtonBase onClick={onPrevPage} disabled={!pagination.previousTokens[pagination.previousTokens.length - 1] || loading} style={{ color: 'black' }} title="Previous Page"><FaChevronLeft /></ButtonBase>
                <ButtonBase onClick={onNextPage} disabled={!pagination.nextToken || loading} style={{ color: 'black' }} title="Next Page"><FaChevronRight /></ButtonBase>
            </TableFooter>

            {id && <ModalTimesheet onClose={() => nav(pathNames.TIMESHEETS)} timesheet={timesheet} />}
            {timesheetReportModal && <ModalTimesheetReport onClose={() => setTimesheetReportModal(false)} />}
            {newTimesheetModal && <ModalEditTimesheet timesheet={{}} onClose={() => setNewTimesheetModal(false)} />}
            {showConfirm && <ModalConfirm description="Are you sure you want to delete this timesheet?  This cannot be undone." onConfirm={() => onDeleteTimesheet()} onClose={() => setShowConfirm(false)} />}
        </>
    );
};

const getDays = (startDate, endDate) => {
    let days = [];
    for (let i = startDate.clone(); i.isBefore(endDate); i.add(1, 'd')) {
        days.push(i.clone());
    }
    return days;
}

const TimeEntryButton = styled(ButtonBase)`
    display: inline-block;
    padding: 0 1rem;
    margin-right: 0.25rem;
    color: black;
    font-weight: 600;

    &:hover {
        background: ${theme.palette.light};
        border: 1px solid ${theme.palette.border};

    }
`;

const CalendarTableData = styled(TableData)`
    font-weight: 600;
    text-align: right;
    cursor: ${(props) => props.length <= 1 ? 'pointer' : 'default'};
    &:hover {
        background: ${theme.palette.borderDark};
    }
`

const CalendarDropdown = ({ value, onChange, disabled }) => {
    const [visible, setVisible] = useState(false);
    return (
        <DropdownContainer>
            <LightButton onClick={() => setVisible(!visible)} disabled={disabled}><FaCalendar /></LightButton>
            <DropdownContent style={{ left: 0, right: 'inherit', display: visible ? 'block' : 'none', padding: '1rem' }}>
                <Calendar
                    onChange={(v) => {
                        onChange(v)
                        setVisible(false);
                    }}
                    value={value}
                />
            </DropdownContent>
        </DropdownContainer>
    )
}

const CalendarTabContainer = () => (
    <TabContent tabId={1}>
        <CalendarTab />
    </TabContent>
)

const CalendarTab = () => {
    const errorContext = useContext(ErrorContext);
    const { control, errors, watch } = useForm();
    const locationId = useSelector(selectActive);
    const fieldProps = { control, errors, locationId }
    const dispatch = useDispatch();
    const timeEntries = useSelector(selectTimeEntries);
    const loading = useSelector(selectLoading);
    const [timeEntry, setTimeEntry] = useState(null);
    const [loadedCalendar, setLoadedCalendar] = useState(null);

    moment.updateLocale('en', { week: { dow: 1 } });

    const [state, localDispatch] = useReducer((state, action) => {
        let d
        switch (action.type) {
            case "ADD":
                d = state.date.clone().add(1, 'w');
                break;
            case "SUB":
                d = state.date.clone().subtract(1, 'w');
                break;
            case "SET":
                d = moment(action.payload);
                break;
            case "TODAY":
                return {
                    date: moment(),
                    startDate: moment().startOf('w'),
                    endDate: moment().endOf('w'),
                };
            default:
                return state;
        }
        return {
            date: d,
            startDate: d.clone().startOf('w'),
            endDate: d.clone().endOf('w'),
        };
    }, { date: moment(), startDate: moment().startOf('w'), endDate: moment().endOf('w') });

    const crewMemberId = watch('crewMemberId');
    const calendarLoaded = loadedCalendar?.state === state && loadedCalendar?.crewMemberId === crewMemberId?.value && loadedCalendar?.locationId === locationId;
    const days = getDays(state?.startDate, state?.endDate);

    useEffect(() => {
        const controller = new AbortController();
        setLoadedCalendar(null);
        (async () => {
            try {
                if (crewMemberId?.value) {
                    const entries = await dispatch(fetchTimeEntriesByCrewMemberId(crewMemberId.value, locationId, state.startDate, state.endDate, null, null, true, undefined, undefined, { fetchAll: true, signal: controller.signal }));
                    if (!controller.signal.aborted && entries) setLoadedCalendar({ state, crewMemberId: crewMemberId.value, locationId });
                }
            } catch (ex) {
                if (!controller.signal.aborted) errorContext.setError({ errorMessage: "Failed to get users time entries.", forSupport: ex.message });
            }
        })()
        return () => controller.abort();
    }, [state, crewMemberId, locationId])

    const byCustomer = groupBy(timeEntries, 'customer.name');

    const onClickAddTimeEntry = () => {
        let date = moment();
        date.set({
            dayOfYear: state.date.dayOfYear(),
            year: state.date.year(),
        })
        console.log(date.toISOString());
        setTimeEntry({
            date,
            crewMember: crewMemberId ? { id: crewMemberId?.value, name: crewMemberId?.label } : undefined
        })
    }

    return (
        <>
            <ActionContainer style={{ alignItems: 'center', marginTop: '1rem' }}>
                <DarkButton onClick={() => localDispatch({ type: "TODAY" })}>Today</DarkButton>
                <CalendarDropdown onChange={(value) => localDispatch({ type: "SET", payload: value })} value={state.date} />
                <LightButton onClick={() => localDispatch({ type: "SUB" })}><FaChevronLeft /></LightButton>
                <LightButton onClick={() => localDispatch({ type: "ADD" })}><FaChevronRight /></LightButton>

                <Pmb>{state?.startDate?.format('MMM DD')} - {state?.endDate?.format('MMM DD, YYYY')}</Pmb>
                <div style={{ flex: 1 }} />
                <WhiteButton onClick={onClickAddTimeEntry}><FaPlus /> Add Time Entry</WhiteButton>
                <FormSelectCrewMember showAll {...fieldProps} name="crewMemberId" containerStyle={{ minWidth: '425px' }} />
            </ActionContainer>

            <Table>
                <thead>
                    <tr>
                        <TableHeader>Customer</TableHeader>
                        {days.map((day, i) => <TableHeader key={`header-column-${i}`} width="10%" style={{ background: day.isSame(moment(), 'd') ? theme.palette.dark : '#000' }} colSpan="1">{day.format('ddd')}<br />{day.format('MMM DD')}</TableHeader>)}
                        <TableHeader width="7%">Customer<br />Total</TableHeader>
                    </tr>
                </thead>
                <tbody>

                    {loading && <TableRow><TableData colSpan={9}><FaSpinner className='fa-spin' /></TableData></TableRow>}
                    {crewMemberId?.value && calendarLoaded && !loading && orderBy(Object.entries(byCustomer), ([customer, ce]) => customer).map(([customer, customerEntries], i) => (
                        <TableRow style={{ cursor: 'default' }} key={`customer-row-${i}`}>
                            <TableData>{customer}</TableData>
                            {days.map((day, i) => {
                                const dayTimeEntries = customerEntries.filter(te => moment(te.date).isSame(day, 'd'))
                                return (
                                    <CalendarTableData
                                        key={`data-column-${i}`}
                                        length={dayTimeEntries.length}
                                        onClick={() => {
                                            let now = moment();
                                            now.set({ dayOfYear: day.dayOfYear(), year: day.year() })
                                            switch (dayTimeEntries.length) {
                                                case 1:
                                                    setTimeEntry(dayTimeEntries[0])
                                                    break;
                                                case 0:
                                                    setTimeEntry({
                                                        date: now,
                                                        crewMember: { id: crewMemberId?.value, name: crewMemberId?.label },
                                                        customer: { id: customerEntries[0]?.customer?.id, name: customerEntries[0]?.customer?.name },
                                                        scope: { id: customerEntries[0]?.scope?.id, name: customerEntries[0]?.scope?.name }
                                                    })
                                                    break;
                                                default:
                                                //There is more than 1 time entry in the box, the click action is handled below.
                                            }
                                        }}
                                    >
                                        {dayTimeEntries.length > 1 && dayTimeEntries.map(te => (
                                            <TimeEntryButton onClick={() => setTimeEntry(te)}>{te.hours}</TimeEntryButton>
                                        ))}
                                        {dayTimeEntries.length === 1 && dayTimeEntries[0].hours}
                                    </CalendarTableData>
                                )
                            })}
                            <TableData style={{ fontWeight: 600, textAlign: 'right' }}>
                                {customerEntries.reduce((t, te) => t + te.hours, 0)}
                            </TableData>
                        </TableRow>
                    ))}
                    {
                        (!loading && (!crewMemberId?.value || (calendarLoaded && !timeEntries.length))) &&
                        <TableRow style={{ height: '4rem' }}><TableData colSpan={9}>There are no time entries in this time range</TableData></TableRow>
                    }
                    {calendarLoaded && !loading && <TableRow style={{ cursor: 'default', fontWeight: 600 }}>
                        <TableHeader>Totals</TableHeader>
                        {days.map((day, i) => (
                            <TableHeader key={`footer-column-${i}`} style={{ textAlign: 'right', background: day.isSame(moment(), 'd') ? theme.palette.dark : '#000' }}>
                                {timeEntries.filter(te => moment(te.date).isSame(day, 'd')).reduce((t, te) => t + te.hours, 0)}
                            </TableHeader>
                        ))}
                        <TableHeader style={{ textAlign: 'right' }}>{timeEntries.reduce((t, te) => t + te.hours, 0)}</TableHeader>
                    </TableRow>}
                </tbody>
            </Table>
            {timeEntry && <ModalEditTimeEntry state={state} timeEntry={timeEntry} onClose={() => setTimeEntry(null)} />}
        </>
    );
}


export default ScreenListTimesheets;
